import { Container, Grid, GridItem } from '@chakra-ui/react';
import { TripPacksFilters, DestinationBox, Footer, HeroSection } from 'components';
import { sampleHotels } from 'data';
import { useHistory } from "react-router-dom";
import { Heading } from 'elements';
import { HERO_IMG_URL } from 'data';
import { routes } from 'utils';

const TripPacks = () => {
  const history = useHistory();

  return (
    <>
      {/** hero section */}
      <Container maxW='container.xl'>
        <HeroSection filter={<TripPacksFilters />} heading='One place, for everything' bgImage={HERO_IMG_URL.trip_packs} />
      </Container>
      {/** hero section */}
      <Container maxW='container.xl' padding='1.5rem 3rem'>
        <Heading />
      </Container>
      <Container maxW='container.xl'>
        <Grid templateColumns='repeat(auto-fit, minmax(250px, 1fr))' gap={6} justifyItems='center'>
          {sampleHotels.map((data) => (
            <GridItem key={data.id} onClick={() => history.push(routes.PACKAGES.TRIP_PACK_RESULTS)}>
              <DestinationBox data={data} />
            </GridItem>
          ))}
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export { TripPacks };
